// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file remote_management_service.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { TraceContext } from "./common_pb.js";

/**
 * @generated from enum cuda_learning.StartJetsonNanoStatus
 */
export enum StartJetsonNanoStatus {
  /**
   * @generated from enum value: START_JETSON_NANO_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: START_JETSON_NANO_STATUS_IN_PROGRESS = 1;
   */
  IN_PROGRESS = 1,

  /**
   * @generated from enum value: START_JETSON_NANO_STATUS_SUCCESS = 2;
   */
  SUCCESS = 2,

  /**
   * @generated from enum value: START_JETSON_NANO_STATUS_ERROR = 3;
   */
  ERROR = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(StartJetsonNanoStatus)
proto3.util.setEnumType(StartJetsonNanoStatus, "cuda_learning.StartJetsonNanoStatus", [
  { no: 0, name: "START_JETSON_NANO_STATUS_UNSPECIFIED" },
  { no: 1, name: "START_JETSON_NANO_STATUS_IN_PROGRESS" },
  { no: 2, name: "START_JETSON_NANO_STATUS_SUCCESS" },
  { no: 3, name: "START_JETSON_NANO_STATUS_ERROR" },
]);

/**
 * @generated from enum cuda_learning.AcceleratorHealthStatus
 */
export enum AcceleratorHealthStatus {
  /**
   * @generated from enum value: ACCELERATOR_HEALTH_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCELERATOR_HEALTH_STATUS_HEALTHY = 1;
   */
  HEALTHY = 1,

  /**
   * @generated from enum value: ACCELERATOR_HEALTH_STATUS_UNHEALTHY = 2;
   */
  UNHEALTHY = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AcceleratorHealthStatus)
proto3.util.setEnumType(AcceleratorHealthStatus, "cuda_learning.AcceleratorHealthStatus", [
  { no: 0, name: "ACCELERATOR_HEALTH_STATUS_UNSPECIFIED" },
  { no: 1, name: "ACCELERATOR_HEALTH_STATUS_HEALTHY" },
  { no: 2, name: "ACCELERATOR_HEALTH_STATUS_UNHEALTHY" },
]);

/**
 * @generated from message cuda_learning.StartJetsonNanoRequest
 */
export class StartJetsonNanoRequest extends Message<StartJetsonNanoRequest> {
  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 1 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<StartJetsonNanoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StartJetsonNanoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartJetsonNanoRequest {
    return new StartJetsonNanoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartJetsonNanoRequest {
    return new StartJetsonNanoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartJetsonNanoRequest {
    return new StartJetsonNanoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartJetsonNanoRequest | PlainMessage<StartJetsonNanoRequest> | undefined, b: StartJetsonNanoRequest | PlainMessage<StartJetsonNanoRequest> | undefined): boolean {
    return proto3.util.equals(StartJetsonNanoRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.StartJetsonNanoResponse
 */
export class StartJetsonNanoResponse extends Message<StartJetsonNanoResponse> {
  /**
   * @generated from field: cuda_learning.StartJetsonNanoStatus status = 1;
   */
  status = StartJetsonNanoStatus.UNSPECIFIED;

  /**
   * @generated from field: string step = 3;
   */
  step = "";

  /**
   * @generated from field: string message = 5;
   */
  message = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 7 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<StartJetsonNanoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StartJetsonNanoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(StartJetsonNanoStatus) },
    { no: 3, name: "step", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartJetsonNanoResponse {
    return new StartJetsonNanoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartJetsonNanoResponse {
    return new StartJetsonNanoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartJetsonNanoResponse {
    return new StartJetsonNanoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartJetsonNanoResponse | PlainMessage<StartJetsonNanoResponse> | undefined, b: StartJetsonNanoResponse | PlainMessage<StartJetsonNanoResponse> | undefined): boolean {
    return proto3.util.equals(StartJetsonNanoResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.CheckAcceleratorHealthRequest
 */
export class CheckAcceleratorHealthRequest extends Message<CheckAcceleratorHealthRequest> {
  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 1 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<CheckAcceleratorHealthRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.CheckAcceleratorHealthRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckAcceleratorHealthRequest {
    return new CheckAcceleratorHealthRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckAcceleratorHealthRequest {
    return new CheckAcceleratorHealthRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckAcceleratorHealthRequest {
    return new CheckAcceleratorHealthRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckAcceleratorHealthRequest | PlainMessage<CheckAcceleratorHealthRequest> | undefined, b: CheckAcceleratorHealthRequest | PlainMessage<CheckAcceleratorHealthRequest> | undefined): boolean {
    return proto3.util.equals(CheckAcceleratorHealthRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.CheckAcceleratorHealthResponse
 */
export class CheckAcceleratorHealthResponse extends Message<CheckAcceleratorHealthResponse> {
  /**
   * @generated from field: cuda_learning.AcceleratorHealthStatus status = 1;
   */
  status = AcceleratorHealthStatus.UNSPECIFIED;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: string server_version = 5 [json_name = "server_version"];
   */
  serverVersion = "";

  /**
   * @generated from field: string library_version = 7 [json_name = "library_version"];
   */
  libraryVersion = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 9 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<CheckAcceleratorHealthResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.CheckAcceleratorHealthResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(AcceleratorHealthStatus) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "server_version", jsonName: "server_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "library_version", jsonName: "library_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckAcceleratorHealthResponse {
    return new CheckAcceleratorHealthResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckAcceleratorHealthResponse {
    return new CheckAcceleratorHealthResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckAcceleratorHealthResponse {
    return new CheckAcceleratorHealthResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckAcceleratorHealthResponse | PlainMessage<CheckAcceleratorHealthResponse> | undefined, b: CheckAcceleratorHealthResponse | PlainMessage<CheckAcceleratorHealthResponse> | undefined): boolean {
    return proto3.util.equals(CheckAcceleratorHealthResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.MonitorJetsonNanoRequest
 */
export class MonitorJetsonNanoRequest extends Message<MonitorJetsonNanoRequest> {
  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 1 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<MonitorJetsonNanoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.MonitorJetsonNanoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MonitorJetsonNanoRequest {
    return new MonitorJetsonNanoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MonitorJetsonNanoRequest {
    return new MonitorJetsonNanoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MonitorJetsonNanoRequest {
    return new MonitorJetsonNanoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MonitorJetsonNanoRequest | PlainMessage<MonitorJetsonNanoRequest> | undefined, b: MonitorJetsonNanoRequest | PlainMessage<MonitorJetsonNanoRequest> | undefined): boolean {
    return proto3.util.equals(MonitorJetsonNanoRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.MonitorJetsonNanoResponse
 */
export class MonitorJetsonNanoResponse extends Message<MonitorJetsonNanoResponse> {
  /**
   * @generated from field: string data = 1;
   */
  data = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 3 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<MonitorJetsonNanoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.MonitorJetsonNanoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MonitorJetsonNanoResponse {
    return new MonitorJetsonNanoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MonitorJetsonNanoResponse {
    return new MonitorJetsonNanoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MonitorJetsonNanoResponse {
    return new MonitorJetsonNanoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MonitorJetsonNanoResponse | PlainMessage<MonitorJetsonNanoResponse> | undefined, b: MonitorJetsonNanoResponse | PlainMessage<MonitorJetsonNanoResponse> | undefined): boolean {
    return proto3.util.equals(MonitorJetsonNanoResponse, a, b);
  }
}

